// import * as moment from 'moment-timezone';

import * as moment from 'moment';


export class Utils {

    static formatDataComHoras(d) {
        return moment(new Date(moment(d).format())).format("YYYY-MM-DD HH:mm:ss");
    }

    static formatDataComHoraLiteral(d) {
        return moment(new Date(moment(d).format())).format("dddd MMMM DD HH:mm:ss YYYY");
    }

    static formatData(d) {
        return moment(new Date(moment(d).format())).format("'yyyy-MM-dd'T'HH:mm:ss.SSSZ");
    }

    //Função que retorna 40 anos antes e 40 anos depois da data atual
    static listaAnos(): number[] {
        let listaAnos = []
        let anoAtual = new Date().getFullYear();
        listaAnos.push(anoAtual);
        for (let index = anoAtual + 40; index > 1980; index--) {
            if (index != anoAtual) {
                listaAnos.push(index);
            }
        }
        return listaAnos
    }

    static listaModuleStatus() {
        return [{ id: "ON_FIELD", value: "No Campo" },
        { id: "TRUCK_LOAD", value: "Transporte" },
        { id: "ON_GATEWAY", value: "Na Balança" },
        { id: "GIN_YARD", value: "Pátio" },
        { id: "GINNING_ORDER", value: "Ordem de Beneficiamento" },
        { id: "GINNING", value: "Beneficiando" },
        { id: "GINNED", value: "Beneficiado" },
        { id: "LOSS", value: "Perda" },]
    }

    static listaModuleType() {
        return [{ id: "RETANGULAR", value: "Retangular" },
        { id: "RETANGULAR_CASE", value: "Case" },
        { id: "CILINDRICO", value: "Cilindrico" },]
    }

    static removeEmpty(obj) {
        Object.keys(obj).forEach((key) => {
            if (obj[key] && (typeof obj[key] === 'object')) {
                if (obj[key] instanceof Date) {
                    return;
                }
                const childObject = this.removeEmpty(obj[key]);
                if (childObject === undefined) {
                    delete obj[key];
                }
            } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
                delete obj[key];
            }
        });
        return Object.keys(obj).length > 0 || obj instanceof Array ? obj : undefined;
    };

    static openImage(data: any) {
        var image = new Image();
        image.src = data;
        var w = window.open("");
        w.document.write(image.outerHTML);
    }

    static sanitizarTexto(texto: any): any {
        if (typeof texto !== 'string') {
            return texto;
        }
        return texto.replace(/\uFFFD/g, '').replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, '');
    }

    static sanitizarRegistro(obj: any): any {
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        try {
            if (Array.isArray(obj)) {
                obj.forEach((item, index) => {
                    if (typeof item === 'string') {
                        obj[index] = Utils.sanitizarTexto(item);
                    } else if (typeof item === 'object' && item !== null && !(item instanceof Date)) {
                        Utils.sanitizarRegistro(item);
                    }
                });
                return obj;
            }
            Object.keys(obj).forEach(key => {
                if (typeof obj[key] === 'string') {
                    obj[key] = Utils.sanitizarTexto(obj[key]);
                } else if (typeof obj[key] === 'object' && obj[key] !== null && !(obj[key] instanceof Date)) {
                    Utils.sanitizarRegistro(obj[key]);
                }
            });
        } catch (e) {
            // Silencioso para garantir que não interrompa fluxos de tela
        }
        return obj;
    }

}

export default Utils;